export const GET_ORG_TAX_DECLARATION_SETTINGS = 'GET_ORG_TAX_DECLARATION_SETTINGS';
export const UPDATE_ORG_TAX_DECLARATION_SETTINGS = 'UPDATE_ORG_TAX_DECLARATION_SETTINGS';
export const FETCH_GENERIC_WINDOW = 'FETCH_GENERIC_WINDOW';
export const CREATE_UPDATE_WINDOW = 'CREATE_UPDATE_WINDOW';
export const DELETE_CUSTOM_WINDOW = 'DELETE_CUSTOM_WINDOW';
export const GET_CUSTOM_WINDOW    = 'GET_CUSTOM_WINDOW';
export const UPDATE_CUSTOM_WINDOW = 'UPDATE_CUSTOM_WINDOW';